module.exports = __webpack_public_path__ + "static/media/miðgarðsormur.8cfc1c4f.svg";